const setLocalStorage = (key, value) => {
  let val = value;
  if (typeof val === 'object') {
    try {
      val = JSON.stringify(val)
    } catch (err) {
      console.error('Set Local Storage', err)
    }
  }
  localStorage.setItem(key, val);
};

const getLocalStorage = (key) => {
  return localStorage.getItem(key);
};

const delLocalStorage = (key) => {
  localStorage.removeItem(key)
};

export { setLocalStorage, getLocalStorage, delLocalStorage }


// WEBPACK FOOTER //
// ./src/app/utils/storage.js